import ThemeModal from "components/Common/ThemeModal"
import { useFilteredVehicleOptions } from "hooks/stockFilterHook"
import CustomerForm from "pages/CustomerPages/Customer/CustomerForm"
import { useCallback, useMemo } from "react"

const QuotationCustomerForm = ({
  isOpen,
  toggle,
  onCustomer,
  initialData = null,
  title = "Add New Customer",
  submitText = "Add Customer",
}) => {
  const {
    isLoading: optionLoading,
    raw: rawData,
    refetch: refetchOptions,
  } = useFilteredVehicleOptions()

  const customerData = rawData?.customer ?? {}

  const formOptions = useMemo(
    () => ({
      designations: customerData?.designations ?? [],
      companies: customerData?.companies ?? [],
      banks: customerData?.banks ?? [],
      branches: customerData?.branches ?? [],
      customerTypes: customerData?.customer_types ?? [],
    }),
    [customerData]
  )

  const effectiveInitialData = useMemo(
    () => ({ customer_type: "general", ...(initialData || {}) }),
    [initialData]
  )

  const isLoading = false

  const handleSubmit = useCallback(
    async (values, { resetForm }) => {
      onCustomer(values, initialData)
      resetForm()
      toggle()
    },
    [initialData, onCustomer, toggle]
  )

  const handleCancel = useCallback(() => {
    toggle()
  }, [toggle])

  return (
    <ThemeModal isOpen={isOpen} toggle={toggle} title={title}>
      <CustomerForm
        initialData={effectiveInitialData}
        options={formOptions}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isEdit={false}
        isLoading={isLoading}
        submitButtonText={submitText}
        cancelButtonText="Cancel"
        showAdditionalInfo={true}
      />
    </ThemeModal>
  )
}

export default QuotationCustomerForm
